import React from "react";

import { IconProps } from "../../types/common";

const ClockIcon = ({
  width = "24",
  height = "24",
  style,
  className,
  fillClassName,
  fillColor = "#63696F",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M12.49 2a10 10 0 10.01 19.99A10 10 0 0012.49 2zm.01 18a8 8 0 110-16 8 8 0 010 16zm-.28-13h.06c.4 0 .72.32.72.72v4.54l3.87 2.3c.35.2.46.65.25.99a.71.71 0 01-.98.24l-4.15-2.49a.99.99 0 01-.49-.86V7.72c0-.4.32-.72.72-.72z"
    />
  </svg>
);

export default ClockIcon;
